import { Addon } from '@galaxy/marketplace-apps/v1';
import { Product } from '../shared/product';

export function orderProductsAndAddons(combined: (Product | Addon)[], order: string[]): (Product | Addon)[] {
  if (!order || order.length === 0) {
    return combined || [];
  }
  if (!combined || combined.length === 0) {
    return [];
  }

  const itemMap = (combined || []).reduce((m, curr) => {
    m.set(getUniqueProductAddonId(curr), curr);
    return m;
  }, new Map<string, Product | Addon>());

  const combinedIdList = combined.map(getUniqueProductAddonId);
  const finalOrderedIds = combineProductOrderWithContainedProducts(order, combinedIdList);

  const orderedList = finalOrderedIds.reduce((items, id) => {
    items.push(itemMap.get(id));
    return items;
  }, []) as (Product | Addon)[];

  return orderedList.filter(filterUniqueAndDefined);
}

function filterUniqueAndDefined(elem, pos, arr): boolean {
  return elem && arr.indexOf(elem) === pos;
}

export function combineProductOrderWithContainedProducts(productOrder: string[], itemIds: string[]): string[] {
  if (itemIds == null || itemIds.length === 0) {
    return [];
  }
  if (!productOrder || productOrder.length === 0) {
    return itemIds.filter(filterUniqueAndDefined);
  }
  return productOrder
    .filter((elem) => itemIds.indexOf(elem) >= 0)
    .concat(itemIds)
    .filter(filterUniqueAndDefined);
}

export function getUniqueProductAddonId(thing: any): string {
  return thing['addonId'] || thing['productId'];
}
